/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import { TEAL } from '../constants';
import LifecycleInfoDialog from './LifecycleInfoDialog';

const RIBBON_WIDTH = 34;
const RIBBON_WIDTH_HOVER = 42;

// Hidden by default — a flat ribbon tab hooked to the right edge of the
// window. Grows slightly on hover; click opens the detailed lifecycle
// infographic + history dialog.
export default function LifecycleRibbon() {
  const [hovered, setHovered] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={e => e.key === 'Enter' && setOpen(true)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{
          position: 'fixed',
          // Sits directly above components/PharmacySelectorRibbon (also
          // fixed to the right edge, top: 50%, zIndex: 1300) — kept clear
          // of it vertically and layered above it so it's never obscured.
          top: '28%',
          right: 0,
          zIndex: 1301,
          width: hovered ? RIBBON_WIDTH_HOVER : RIBBON_WIDTH,
          py: 2.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          bgcolor: TEAL,
          color: 'white',
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
          boxShadow: hovered ? '-4px 4px 14px rgba(0,0,0,0.25)' : '-2px 2px 8px rgba(0,0,0,0.18)',
          cursor: 'pointer',
          transition: 'width 0.18s ease, box-shadow 0.18s ease',
        }}
      >
        <TimelineIcon fontSize="small" sx={{ color: '#fff !important' }} />
        <Typography
          variant="caption"
          sx={{
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)',
            fontWeight: 700,
            letterSpacing: '0.08em',
            fontSize: '0.68rem',
            color: '#fff !important',
          }}
        >
          LIFECYCLE
        </Typography>
      </Box>

      <LifecycleInfoDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
